module.exports = __webpack_public_path__ + "assets/img/f69e16665592026a3002fe618705cc21.svg";